/**
 * České bankovní číslo účtu → IBAN a SPAYD (QR platba).
 * Port z frontend/index.html — fakGenerateIBAN a fakV2UpdateQR.
 */

/** Vrací IBAN (CZ...) s mezerami po 4 znacích, nebo `null` při neplatném formátu. */
export function czAccountToIban(ucet: string): string | null {
  const cleaned = ucet.trim();
  const m = cleaned.match(/^(?:(\d{1,6})-)?(\d{2,10})\/(\d{4})$/);
  if (!m) return null;
  const prefix = (m[1] || '').padStart(6, '0');
  const account = m[2].padStart(10, '0');
  const bank = m[3];
  const bban = bank + prefix + account; // 20 číslic
  // CZ → 1235, doplň "00" pro výpočet
  const numStr = bban + '123500';
  let remainder = 0;
  for (let i = 0; i < numStr.length; i++) {
    remainder = (remainder * 10 + Number(numStr[i])) % 97;
  }
  const check = String(98 - remainder).padStart(2, '0');
  const raw = `CZ${check}${bban}`;
  return raw.replace(/(.{4})/g, '$1 ').trim();
}

export interface SpaydOptions {
  iban: string;
  amount?: number;
  currency?: string;
  vs?: string;
  ks?: string;
  ss?: string;
  msg?: string;
}

/** Krátký platební formát dle ČBS — obsah QR platby. */
export function buildSpayd({ iban, amount, currency = 'CZK', vs, ks, ss, msg }: SpaydOptions): string {
  const acc = iban.replace(/\s/g, '');
  const parts: string[] = [`SPD*1.0`, `ACC:${acc}`];
  if (typeof amount === 'number' && isFinite(amount) && amount > 0) {
    parts.push(`AM:${amount.toFixed(2)}`);
  }
  parts.push(`CC:${currency}`);
  if (vs) parts.push(`X-VS:${vs}`);
  if (ks) parts.push(`X-KS:${ks}`);
  if (ss) parts.push(`X-SS:${ss}`);
  if (msg) parts.push(`MSG:${msg}`);
  return parts.join('*') + '*';
}
